export const state = {
    atividadePosVenda: {},
    atividadesPosVenda: [],
    modalExcluirAtividadePosVenda: false,
    modalCadastroAtividadePosVenda: false,
}

export default {}